import React, { useState, useEffect } from "react";
import { UsePrevious } from "../Hook/UsePrevious.js";
import DropDown from "../ReusableComponents/DropDown";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import InputText from "../ReusableComponents/InputText";
import { mainTable } from "../css/Common";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import MainLayout from "../components/MainLayout";
import { consumptionHeader } from "../components/HeaderAttribute";
import { ConsumptionViewHeaders } from "../components/HeaderAttribute";
import GridPage from "../components/GridPage";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import Consumptionpopup from "../popup-containers/Consumptionpopup";
import Loader from "../ReusableComponents/Loader";
import TextArea from "../ReusableComponents/TextArea";
import { IUDAPI, BindAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import { BindPostAPI } from "../services/APIConnection";
import ConsumptionViewPopUp from "../popup-containers/ConsumptionViewPopUp";
import { useCallback } from "react";
import usePrevious from "../Hook/UsePrevious";

const Consumption = () => {
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(true);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [formFields, setFormFields] = useState({ consumedate: "", reason: "", consumptionno: "CON" });
  const [errors, setErrors] = useState({});
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [rowIndex, setRowIndex] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [ConsumptionData, setConsumptionData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [MstConsumptionId, setMstConsumptionId] = useState("");
  const [studentData, setStudentData] = useState([]);
  const [consumptionFileds, setConsumptionFileds] = useState({});
  const [viewAction, setViewAction] = useState(false);
  const [viewpopUpOpen, setviewpopUpOpen] = useState(false)
  const [viewConsumptionDetails, setViewConsumptionDetails] = useState(false);
  const [consumeRecord, setConsumeRecord] = useState([])
  const [consumeTableData, setConsumeTableData] = useState([])
  const [consumeDropdownData, setConsumeDropdownData] = useState([])
  const [consumemainTableData, setConsumemainTableData] = useState([])
  const [mainconsumeRecord, setmainconsumeRecord] = useState([])
  const [consumptionChildPopUpDatas, setConsumptionChildPopUpDatas] = useState([])
  const [dropdownPopUpDatas, setDropdownPopUpDatas] = useState([])
  const [tableError, setTableError] = useState("");

  const [TxnConsumptionId, setTxnConsumptionId] = useState("")
  const [tableData, setTableData] = useState([
    {
      itemtype: '',
      itemcategory: '',
      itemname: '',
      quantity: '',
      uom: '',
      itemList: [], // filtered item list per row
      itemCategoryList: [],
      currentStock:''
    },
  ]);

  const [itemtype, setitemtype] = useState([
    // { value: "cat1", label: "Fixed Asset" },
    // { value: "cat2", label: "Consumables" },
  ])

  const [itemcategorydd, setitemcategorydd] = useState([
    // { value: "cat1", label: "Furnitures" },
    // { value: "cat2", label: "Kitchen Equipment" },
  ])

  const [itemdd, setitemdd] = useState([
    // { value: "Name1", label: "Fan" },
    // { value: "Name2", label: "Table" },
  ])

  const [bindConsumptionData, setBindConsumptionData] = useState([
    // {
    //   sno: 1,
    //   itemType: "Fixed Asset",
    //   items: "Furnitures",
    //   itemName: "Fan",
    //   quantity: "2",
    //   UOM: "Nos"
    // },
    // {
    //   sno: 2,
    //   itemType: "Consumable",
    //   items: "Kitchen Equipment",
    //   itemName: "Table",
    //   quantity: "1",
    //   UOM: "Nos"
    // },
  ]);
  const [bindConsumptionChildData, setBindConsumptionChildData] = useState([])

  const handleInputChangeTable = (e, index) => {
    const { name, value } = e.target;
    const updated = [...tableData];
    updated[index][name] = value;
    setTableData(updated);
  };

  const handleAutoDropdownChange = (e, index) => {
    const { name, value } = e.target;
    setTableData(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [name]: value };
      return updated;
    });
  };

  const cancelview = () => {
    setviewpopUpOpen(false)
  }

// useEffect(() => {
  
//     bindQuantityRemains();
  
// }, [tableData]); // can be replaced with a derived variable if needed

// const bindQuantityRemains = async () => {
//   
//   console.log("Calling bindQuantityRemains");

//   const row = tableData[rowIndex];
//   if (!row) return;

//   const data = {
//     mstClientId: clientId,
//     itemtype: Number(row.itemtype) || 0,
//     itemcategory: Number(row.itemcategory) || 0,
//     itemname: Number(row.itemname) || 0,
//     quantity: Number(row.quantity) || 0,
//   };

//   try {
//     const response = await BindPostAPI(data, "Consumption/BindQuantityRemains");
//     console.log("Remain quantity", response);

//     if (response?.RemainingQuantity ) {
//       toast.success("Sufficient quantity available", {
//         duration: 3000,
//         position: "top-center",
//       });
//     } else {
//       toast.error("Insufficient quantity", {
//         duration: 3000,
//         position: "top-center",
//       });
//     }
//   } catch (error) {
//     console.error("Error calling API", error);
//     toast.error("Failed to fetch quantity data", {
//       duration: 3000,
//       position: "top-center",
//     });
//   }
// };



  const [allItemCategories, setAllItemCategories] = useState([]);
  const [allItems, setAllItems] = useState([]);


  useEffect(() => {
    BindConsumptionData();
  }, []);

  const BindConsumptionData = async () => {

    const data = {
      mstClientId: clientId
    }
    const response = await BindPostAPI(data, "Consumption/BindConsumption");


    console.log("Consumption Response:", response);
    if (response && response.data) {
      setBindConsumptionData(response.data.Table)
      setBindConsumptionChildData(response.data.Table1)


    } else {
      bindConsumptionData([]);
      bindConsumptionChildData([]);

    }
  };



  useEffect(() => {
    BindConsumptionValues();
  }, []);

  const BindConsumptionValues = async () => {

    const response = await BindAPI("Consumption/BindConsumptionValues")
    console.log("Consumption Dropdown:", response);
    if (response && response.data) {
      const ItemTypes = response.data.Table.map((item) => ({
        value: item.MstItemTypeId,
        label: item.ItemType,
      }));
      setitemtype(ItemTypes);

      setitemcategorydd(response.data.Table1); // show all initially


      setitemdd(response.data.Table2); // show all initially



    } else {
      setitemtype([]);
      setitemcategorydd([]);
      setitemdd([]);
    }
  };






  const handleItemTypeChange = (selectedOption, rowIndex) => {
    const selectedTypeId = selectedOption?.value;
    if (!selectedTypeId) return;

    // Filter item categories based on selected ItemType
    const filteredCategories = allItemCategories.filter(
      (cat) => String(cat.itemTypeId) === String(selectedTypeId)
    );

    // Reset items for the selected row since itemname will change based on category
    const resetRow = {
      ...tableData[rowIndex],
      itemtype: selectedTypeId, // Update ItemType for this row
      itemcategory: '', // Reset ItemCategory for this row
      itemname: '', // Reset ItemName for this row
      itemList: [], // Reset item list for this row
      itemCategoryList: filteredCategories,
    };

    // Update only the row that was changed
    setTableData((prev) => {
      const updated = [...prev];
      updated[rowIndex] = resetRow; // Apply the update only to the changed row
      return updated;
    });

    // Update the category list based on the selected type
    setitemcategorydd(filteredCategories); // Update categories available based on the type
    setitemdd([]); // Reset items list (empty for now)
  };



  const handleItemCategoryChange = (selectedOption, rowIndex) => {
    const selectedCategoryId = selectedOption?.value;
    if (!selectedCategoryId) return;

    // Filter items based on selected ItemCategory
    const filteredItems = allItems.filter(
      (it) => String(it.itemCategoryId) === String(selectedCategoryId)
    );

    // Update only the selected row
    setTableData((prev) => {
      const updated = [...prev];
      updated[rowIndex] = {
        ...updated[rowIndex],
        itemcategory: selectedCategoryId, // Update ItemCategory for the selected row
        itemname: '', // Reset ItemName for the selected row
        itemList: filteredItems, // Store filtered items for the row
      };
      return updated;
    });
  };


  const handleItemChange = (selectedOption, rowIndex) => {
    const selectedItemId = selectedOption?.value;
    if (!selectedItemId) return;

    // Update only the selected row's item name
    setTableData((prev) => {
      const updated = [...prev];
      updated[rowIndex] = {
        ...updated[rowIndex],
        itemname: selectedItemId, // Update itemname for this row
      };
      return updated;
    });
  };

  const previousTableData = usePrevious(tableData);

  useEffect(() => {
    updateTableData();
  }, [tableData]);

  const updateTableData = async () => {
    
    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      const updatedTableData = [...tableData];
      console.log(updateTableData)
      console.log("itemcategory", itemcategorydd)
        
      for (const row of updatedTableData) {
        // Update itemCategoryList if itemtype is selected
        if (row?.itemtype) {
          const filteredCategories = itemcategorydd
            .filter((item) => item.MstItemTypeId === row.itemtype)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
        }
          
        // Update itemList and uom if itemcategory is selected
        if (row?.itemcategory) {
          const filteredItems = itemdd

            .filter((item) => item.MstItemCategoryId === row.itemcategory)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;

          const selectedItem = filteredItems.find(
            (item) => item.value === row.itemname
          );
          row.uom = selectedItem?.uom || '';
        }

        if (row?.itemname) {
          
          const data = {
            // mstClientId: clientId,
            // mstItemTypeId: row.itemtype,
            // mstCategoryId: row.itemcategory,
            // mstNameId: row.itemname,
             mstClientId: parseInt(clientId || 0),
            itemtype:  parseInt(row.itemtype || 0),
            itemcategory:  parseInt(row.itemcategory || 0),
            item:  parseInt(row.itemname || 0),
          };
          console.log(data,"consume")

          try {
            const response = await BindPostAPI(
              data,
              "Consumption/BindQuantityRemains"
            );

            const balanceQuantity =
              response?.data?.Table?.[0]?.RemainingQuantity || "";
            row.currentStock = balanceQuantity;
            console.log("balanceQuantity", balanceQuantity);
          } catch (error) {
            console.error("Error fetching current stock:", error);
            row.currentStock = ""; // Reset on error
          }
        }
      }

      setTableData(updatedTableData);
    }
  };


  const updateTableData1 = async (formattedDataArray) => {
    if (JSON.stringify(previousTableData) !== JSON.stringify(formattedDataArray)) {
      const updatedTableData = [...formattedDataArray];
      console.log(updateTableData)
      console.log("itemcategory", itemcategorydd)
        
      for (const row of updatedTableData) {
        // Update itemCategoryList if itemtype is selected
        if (row?.itemtype) {
          const filteredCategories = itemcategorydd
            .filter((item) => item.MstItemTypeId === row.itemtype)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
        }
          
        // Update itemList and uom if itemcategory is selected
        if (row?.itemcategory) {
          const filteredItems = itemdd

            .filter((item) => item.MstItemCategoryId === row.itemcategory)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;

          const selectedItem = filteredItems.find(
            (item) => item.value === row.itemname
          );
          row.uom = selectedItem?.uom || '';
        }
      }

      setTableData(updatedTableData);
    }
  };


  const handleDeleteRow = (index) => {

    if (index === 0) {
     
      const updated = [...tableData];
      updated[0] = {
        itemtype: '',
        itemcategory: '',
        itemname: '',
        quantity: '',
        uom: '',
        itemList: [], // filtered item list per row
        itemCategoryList: [],
        currentStock:''
      };
      setTableData(updated);
    } else {
      // Remove row for other indexes
      setTableData((prev) => prev.filter((_, i) => i !== index));
    }
    // const newTableData = [...tableData];
    // newTableData.splice(index, 1);
    // setTableData(newTableData);
  };


  const handleAddRow = () => {
    setTableData((prev) => {
      if (prev.length >= 4) {
        toast.error("Cannot add more than 4 rows.");
        return prev;
      }
  
      const lastRow = prev[prev.length - 1];
  
      if (!lastRow || !lastRow.itemcategory || !lastRow.itemname) {
        toast.error("Please select both Item Category and Item Name before adding a new row.");
        return prev;
      }
  
      const isDuplicate = prev.some(
        (row, index) =>
          index !== prev.length - 1 &&
          row.itemcategory === lastRow.itemcategory &&
          row.itemname === lastRow.itemname
      );
  
      if (isDuplicate) {
        toast.error("Item with the same category and name already exists.");
        return prev;
      }
  
      const newRow = {
        itemtype: "",
        itemcategory: "",
        itemname: "",
        quantity: "",
        uom: "",
        itemList: [],
        itemCategoryList: [],
        currentStock: "",
      };
  
      return [...prev, newRow]; // append at bottom
    });
  };


  // const handleAddRow = () => {

  //   if (tableData.length >= 4) {
  //   toast.error("Cannot add more than 4 rows.");
  //   return;
  // }
   
  // // Get the last row's itemCategoryId and itemName (if applicable)
  // const lastRow = tableData[tableData.length - 1];

  // // Check if the last row has both itemCategoryId and itemName selected
  // if (lastRow && lastRow.itemcategory && lastRow.itemname) {
  //   // Check for duplicates in tableData
  //   const isDuplicate = tableData.some(
  //     (row, index) =>
  //       index !== tableData.length - 1 && // Exclude the last row itself
  //       row.itemcategory === lastRow.itemcategory &&
  //       row.itemname === lastRow.itemname
  //   );

  //   if (isDuplicate) {
  //     toast.error("Item with the same category and name already exists.");
  //     return;
  //   }

  //   const updatedRows = [...tableData];
  //   updatedRows.splice(updatedRows.length, 0, newRow); 
  //   setTableData(updatedRows);

    
  // } else {
  //   // Optionally, you can add a check to ensure itemCategoryId and itemName are selected
  //   toast.error("Please select both Item Category and Item Name before adding a new row.");
  //   return;
  // }

  // // // Add new row if validation passes
  // // setTableData([
  // //   ...tableData,
  // //   {
  // //     itemType: "",
  // //     itemCategoryId: "",
  // //     itemId: "",
  // //     quantity: "",
  // //     rate: "",
  // //     uom: "",
  // //     itemCategoryList: [],
  // //     itemList: [],
  // //   },
  // // ]);


  //   setTableData([
  //     ...tableData,
  //     {
  //       itemtype: '',
  //       itemcategory: '',
  //       itemname: '',
  //       quantity: '',
  //       uom: '',
  //       itemList: [],
  //       itemCategoryList: [],
  //     },
  //   ]);
  // };

  const onConsumptionView = (rowIndex, flag) => {
    //setpopUpOpen(true)

    // setRowIndex(rowIndex);
     setviewpopUpOpen(true)

    // const consumeDataPop = {

    //   consumedate: bindConsumptionData[rowIndex].ConsumeDate.split('T')[0],
    //   description: bindConsumptionData[rowIndex].Description,
    //   consumptionno: bindConsumptionData[rowIndex].ConsumptionNo,

    // }

    // setConsumeRecord(consumeDataPop);







    const rowdata=bindConsumptionData[rowIndex]
    //setmainconsumeRecord(rowdata);
    setConsumeRecord(rowdata);

    const TesttxnConsumptionId = bindConsumptionData[rowIndex].TxnConsumptionId;


    // Step 1: Filter data for this enquiry
    const filtered = bindConsumptionChildData.filter(
      (item) => item && String(item.TxnConsumptionId) === String(TesttxnConsumptionId)
    );

   setConsumeTableData(filtered)

  }





  const handleConsumption = (rowIndex, flag) => {

    setRowIndex(rowIndex);
    setpopUpOpen(true);
    setConsumptionData(bindConsumptionData[rowIndex]);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }


    // const consumeDataPop = {

    //   consumedate: bindConsumptionData[rowIndex].ConsumeDate.split('T')[0],
    //   description: bindConsumptionData[rowIndex].Description,
    //   consumptionno: bindConsumptionData[rowIndex].ConsumptionNo,

    // }

    

const rowdata=bindConsumptionData[rowIndex]
setmainconsumeRecord(rowdata);

    const TesttxnConsumptionId = bindConsumptionData[rowIndex].TxnConsumptionId;


    // Step 1: Filter data for this enquiry
    const filtered = bindConsumptionChildData.filter(
      (item) => item && String(item.TxnConsumptionId) === String(TesttxnConsumptionId)
    );

    setConsumemainTableData(filtered)


    // // Optional: group by item/type/category
    // const grouped = {};
    // filtered.forEach((item1) => {
    //   const key = `${item1.MstItemId}-${item1.MstItemCategoryId}-${item1.MstItemTypeId}`;
    //   if (!grouped[key]) {
    //     grouped[key] = [];
    //   }
    //   grouped[key].push(item1);
    // });


  };



  const handleEdit = (rowIndex) => {
      
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setTxnConsumptionId(bindConsumptionData[rowIndex].TxnConsumptionId);

    setFormFields({
      ...formFields,

      consumptionno: bindConsumptionData[rowIndex].ConsumptionNo,
      reason: bindConsumptionData[rowIndex].Description,
      consumedate: bindConsumptionData[rowIndex].ConsumeDate.split('T')[0]
    })



    const TesttxnConsumptionId = bindConsumptionData[rowIndex].TxnConsumptionId;


    if (!TesttxnConsumptionId) {
      console.error("TxnConsumptionId not found");
      return;
    }

    const filtered = bindConsumptionChildData.filter(
      (item1) => item1?.TxnConsumptionId === TesttxnConsumptionId
    );
    ///
    //  const txnLaundryIssueId = bindLaundryIssue[rowIndex].TxnLaundryIssuesId;

    // const laundryIssueData = Object.values(bindLaundryIssueChild).filter(
    //   (item) => {
    //     return String(item.TxnLaundryIssuesId) === String(txnLaundryIssueId);
    //   }
    // );
    if (filtered.length === 0) {
      setTableData([
        {
          itemtype: "",
          itemcategory: "",
          itemname: "",
          uom: "",
          quantity: "",

          itemCategoryList: [],
          itemList: []
        },
      ]);
    } else {
      // Append the filtered data to your state using appendDataToState function
      appendDataToConsumeTable(JSON.stringify(filtered));
    }

  };

  const appendDataToConsumeTable = (newDataString) => {

    const newDataArray = JSON.parse(newDataString);
    // handleDeleteRow(0);
    // setTableData([]);
    const formattedDataArray = newDataArray.map((data) => {

      return {
        itemtype: data.MstItemTypeId,
        itemcategory: data.MstItemCategoryId,
        itemname: data.MstItemId,
        uom: data.UOM,
        quantity: data.Quantity,


      };
    });

    setTableData((prevData) => [...prevData, ...formattedDataArray]);
    updateTableData1(formattedDataArray);
    convertArrayToJSONString(formattedDataArray);






  };
  var createdBy = sessionStorage.getItem("createdBy");
  var clientId = sessionStorage.getItem("MstClientId");


const [error,setError]=useState({
  consumedate:""
})

  const handleSubmit = async (rowIndex, flag) => {

      
    setTableError("");
    if (flag === 1 || flag === 2) {
    const isTableValid = tableData.some(
      (row) =>
        row.itemtype !== "" &&
        row.itemcategory !== "" &&
        row.itemname !== "" &&
        row.quantity !== ""
    );
  
    if (!isTableValid) {
      setTableError("Please fill the above table.");
      toast.error("Please fill the above table.");
      setIsLoading(false);
      return;
    }
    }
    //setSubmitBtnDisabled(true);
    //setIsLoading(true);
    // Submit logic

    const cleanedPayload = tableData.map(row => ({
      itemtype: Number(row.itemtype) || 0,
      itemcategory: Number(row.itemcategory) || 0,
      itemname: Number(row.itemname) || 0,
      quantity: Number(row.quantity) || 0,
      uom: row.uom?.trim() || ''
    }));

    if (flag == 1 || flag == 2) {
for (let i = 0; i < tableData.length; i++) {
    const row = tableData[i];

    if (
      row.itemtype === "" ||
      row.itemcategory === "" ||
      row.itemname === "" ||
      row.quantity === ""
    ) {
      // toast.error(`Please fill all required fields in row ${i + 1}.`);
       toast.error("Please enter all mandatory fields.");
      return;
    }
  }

      const newErrors = {
                //receiptno: formFields.receiptno ? "" : "Enter Receipt No",
                consumedate: formFields.consumedate ? "" : "Enter Consumption Date",
               // receivedFrom: formFields.receivedFrom ? "" : "Enter Received From",
               // receivedBy: formFields.receivedBy ? "" : "Enter Received By",
              };
              setErrors(newErrors);
      
              const isFormValid = Object.values(newErrors).every((err) => err === "");
              if (!isFormValid) {
                toast.error("Please enter all mandatory fields.");
                setIsLoading(false);
                return;
              }  else{

                setSubmitBtnDisabled(true);
                setIsLoading(true);
      const data = {                     // data to be send to api, if add/update

        txnConsumptionId: TxnConsumptionId ? TxnConsumptionId : 0,
        consumptionNo: formFields.consumptionno || "CON",
        consumeDate: formFields.consumedate || "2025-08-02",
        description: formFields.reason || "",
        mstClientId: clientId,

        consumptionChild: JSON.stringify(cleanedPayload),
        createdBy: createdBy,
        flag: flag,
      };

      console.log("cleanedPayload", cleanedPayload);
      console.log("stringified", JSON.stringify(cleanedPayload, null, 2));

      const response = await IUDAPI(data, "Consumption/IUDConsumption");
      if (flag == 1) {                                              //if flag ==1 , add
        if (response.data.Table[0].Result === 'S') {
          toast.success("Consumption Data Inserted Successfully", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Consumption data insert Failed", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 2) {                     //if flag ==2 , update

        if (response.data.Table[0].Result === "M") {
          toast.success("Consumption data modified successfully! 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Consumption data modification failed 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
}
    } else if (flag == 3) {
      const data = {                     // data to be send to api, if add/update

        txnConsumptionId: bindConsumptionData[rowIndex].TxnConsumptionId,
        consumptionNo:bindConsumptionData[rowIndex].ConsumptionNo,
        createdBy: createdBy,
        flag: flag,

      };


      const response = await IUDAPI(data, "Consumption/IUDConsumption");

      if (flag == 3) {                                            //if flag ==3 , delete
        if (response.data.Table[0].Result === 'D') {
          toast.success("Consumption Data Deleted Successfully", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Failed to delete Consumption Data ", {
            duration: 3000,
            position: "top-center",
          });
        }
        setTimeout(cancel, 3000);



      }
    }
  };

  const cancel = () => {
    setVisibleAdd(false);
    setIsLoading(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setpopUpOpen(false);
    BindConsumptionData();
    setTableError("");
     setFormFields({consumedate: "", reason: "", consumptionno: "CON"})
    
    // setFormFields([{consumedate: "", reason: ""}])
    setTableData([
      {
        itemtype: "",
        itemcategory: "",
        itemname: "",
        uom: "",
        quantity: "",
       
        itemCategoryList: [],
        itemList: []
      },
    ]);
  };






  useEffect(() => {
    // Get the current TxnConsumptionId from the bindConsumptionData based on rowIndex
    const currentTxnConsumptionId = bindConsumptionData[rowIndex]?.TxnConsumptionId;

    if (!currentTxnConsumptionId) return; // If the TxnConsumptionId is invalid or undefined, return

    // Step 1: Filter the corresponding data from bindConsumptionChildData
    const filteredData = bindConsumptionChildData.filter(
      (item) => item && item.TxnConsumptionId === currentTxnConsumptionId
    );

    // Step 2: Set the filtered data in state (for the dropdown or other UI elements)
    setConsumeTableData(filteredData);

    // Step 3: Map the filtered data to dropdown values (assuming you want to pass values to dropdowns)
    if (filteredData.length > 0) {
      const consume = filteredData[0]; // Assuming you want the first row

      const getDropdownValue = (dropdown, id, label = "Unknown") => {
        const found = dropdown.find((item) => item.value === id);
        return { value: id, label: found ? found.label : label };
      };

      const ItemTypeValue = getDropdownValue(itemtype, consume.MstItemTypeId);
      const ItemCategoryValue = getDropdownValue(itemcategorydd, consume.MstItemCategoryId);
      const ItemValue = getDropdownValue(itemdd, consume.MstItemId);

      const dropdownvalues = [
        [ItemTypeValue],
        [ItemCategoryValue],
        [ItemValue],
      ];

      setConsumeDropdownData(dropdownvalues);
    }
  }, [bindConsumptionData, rowIndex, bindConsumptionChildData, itemtype, itemcategorydd, itemdd]);




  // const handleInputChange = (selectedOption, rowIndex, columnName) => {
  //   const value = selectedOption ? selectedOption.value : "";

  //   // Update the state with the new value
  //   setTableData((prevTableData) => {
  //     const updatedData = [...prevTableData];
  //     updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };

  //     // Ensure side effect is based on the latest updatedData
  //     //   convertArrayToJSONString(updatedData);

  //     return updatedData;
  //   });
  // };


  const handleInputChangeForm = (e) => {
    const { name, value } = e.target;
    setFormFields((prevData) => ({
      ...prevData,
      [name]: value
    }));
  }



  const [popUpData, setPopUpData] = useState()

  const handleState = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);

      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);

      setUnBlockDetails(true);
    }

    const rowData = bindConsumptionData[rowIndex];
    setTxnConsumptionId(bindConsumptionData[rowIndex].TxnConsumptionId);
    setPopUpData(rowData);



  };
  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      //setLaundryIssueDetails(jsonString);
      console.log("data", tableData)

      console.log("JsonString", jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };
const handleInputChange = (selectedOption, rowIndex, columnName) => {
  const value = selectedOption ? selectedOption.value : "";

  // ✅ Use the correct variable: tableData
  const currentRow = tableData[rowIndex];

  // Validate for duplicates when itemcategory or itemname changes
  if (columnName === "itemcategory" || columnName === "itemname") {
    const isDuplicate = tableData.some(
      (row, index) =>
        index !== rowIndex &&
        row.itemcategory === (columnName === "itemcategory" ? value : currentRow.itemcategory) &&
        row.itemname === (columnName === "itemname" ? value : currentRow.itemname) &&
        row.itemcategory &&
        row.itemname
    );

    if (isDuplicate) {
      toast.error("Item with the same category and name already exists in the table.");
      return;
    }
  }

  setTableData((prevTableData) => {
    const updatedData = [...prevTableData];
    updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
    convertArrayToJSONString(updatedData); // Assuming this updates somewhere else
    return updatedData;
  });
};


  const fieldLabels = {
    consumedate: { label: "Consumption Date", type: "date" },
    itemtype: { label: "Item Type", type: "select-one" },
    itemcategory: { label: "Item Category", type: "select-one" },
    itemname: { label: "Item Name", type: "select-one" },
    quantity: { label: "Quantity", type: "number" },
    //enquirydate: { label: "Enquiry Date", type: "date" },
    //number: { label: "Mobile Number", type: "text" },
    // Add more fields here as needed
  };
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  
    // Reset form fields when opening Add
    setFormFields(
      {
        consumedate: "",
        reason: "",
        consumptionno: "CON",
      },
    );
  
    // Reset table rows too
    setTableData([
      {
        itemtype: "",
        itemcategory: "",
        itemname: "",
        uom: "",
        quantity: "",
      },
    ]);
  };

  const handleBlur = (e) => {

     const { name, value } = e.target;
     const field = fieldLabels[name];
    if (!field) return;

    const label = field.label;
    const type = field.type;

    const message =
      value.trim() === ""
        ? type === "select-one"
          ? `Select ${label}`
          : `Enter ${label}`
        : "";
     setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: message,
    }));
   }


   const handleTableBlur = (rowIndex, e) => {
  const { name, value } = e.target;
  const field = fieldLabels[name];
  if (!field) return;

  const label = field.label;
  const type = field.type;

  const message =
    value.trim() === ""
      ? type === "select-one"
        ? `Select ${label}`
        : `Enter ${label}`
      : "";

  setErrors((prevErrors) => {
    const updatedErrors = [...prevErrors];
    if (!updatedErrors[rowIndex]) {
      updatedErrors[rowIndex] = {};
    }
    updatedErrors[rowIndex][name] = message;
    return updatedErrors;
  });
};

  return (
    <MainLayout pageName={"3"}>
      <Loader isVisible={isLoading} size="h-20 w-20" color="border-t-black" blur={true} />

      {visibleTable && (
        <GridPage
          header={consumptionHeader}
          title={"Consumption"}
          records={bindConsumptionData}
          handleEdit={handleEdit}
          handleAction={handleConsumption}
          showAdd={showAdd}
           
          blockview={true}
          onConsumptionView={onConsumptionView}
        />
      )}

      {viewAction && (
        <GridPage
          title={`Consumption > ${consumptionFileds.consumptionNo} > ${consumptionFileds.commodities}  `}
          header={ConsumptionViewHeaders}
          records={studentData}
          tableHeight="h-56"
          addView={true}
          handleAction={handleState}
        />
      )}

      {visibleAdd && (
        <div className="w-full">
          <div className="flex flex-col w-full">
            <div className={mainTable.clientMasterMainAdd}>
              <AddScreenTitle
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                title="Consumption"
              />
            </div>
          </div>

          <div className="mt-10"></div>

          <div className={mainTable.grid3}>

            { /*<div className="w-60 mt-12 mb-6">*/}
            <InputText
              title="Consumption No"
              inputType="text"
              disabled={true}
              name="consumptionno"
              content={formFields.consumptionno}
              controlFunc={handleInputChangeForm}
            />
            {/* </div>*/}

            <InputText
              inputType="date"
              title="Date"
              name="consumedate"
              controlFunc={handleInputChangeForm}

              controlFuncBlur={handleBlur}

              content={formFields.consumedate}
              placeholder="Enter Date"
              disabled={false}
              // tabIndex="9"
              isRequired={true}
              errorMessage={errors.consumedate}
              classStar="text-red-500"
            />

          </div>

          <div className="w-full  max-h-[400px] ">
            <table className="w-full border border-gray-300 mt-6">
              <thead className="bg-[#3D6643] text-white sticky top-0 z-10">
                <tr>
                  <th className="border px-4 py-2">S.No</th>
                  <th className="border px-4 py-2">ItemsType</th>
                  <th className="border px-4 py-2">Item Category</th>
                  <th className="border px-4 py-2">ItemName</th>
                  <th className="border px-4 py-2">U.O.M</th>
                  <th className="border px-4 py-2">Quantity</th>


                  <th className="border px-4 py-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={row.id || index}> {/* Unique identifier for each row */}
                    <td className="border px-1 py-2 w-[10px] text-center">{index + 1}</td>
                    {/* Item Type */}
                    <td className="border px-2 py-2 w-[160px] relative overflow-visible">
                      <div className="w-40"></div>
                      <AutoDropDown
                        name="itemtype"
                        type="select-one"
                        options={itemtype || []}
                        placeholder="Select"
                        Class="custom-class"
                        errorMessage={errors.itemtype}
                        controlFunc={(e) => {
                          handleInputChange(e, index, "itemtype");
                        }}
                        selectedOption={
                          row.itemtype
                            ? itemtype.find((x) => x.value === row.itemtype)
                            : ""
                        }

                      />

                    </td>

                    {/* Item Category */}
                    <td className="border px-2 py-2 w-[160px] relative overflow-visible">
                      <div className="w-40"></div>
                      <AutoDropDown
                        name="itemcategory"
                         type="select-one"
                        options={row.itemCategoryList || []}
                        errorMessage={errors.itemcategory}
                        selectedOption={
                          row.itemcategory
                            ? row.itemCategoryList.find((x) => x.value === row.itemcategory)
                            : ""
                        }
                        placeholder="Select"
                        Class="custom-class"
                        controlFunc={(e) => handleInputChange(e, index, "itemcategory")}
                      />
                    </td>


                    <td className="border px-2 py-2 w-[160px] relative overflow-visible">
                      <div className="w-40"></div>
                      <AutoDropDown
                        name="itemname"
                         type="select-one"
                         errorMessage={errors.itemname}
                        options={row.itemList || []} // row-specific filtered list
                        selectedOption={
                          row.itemname
                            ? row.itemList.find(
                              (x) => x.value == row.itemname
                            )
                            : ""
                        }// safe access
                        placeholder="Select"
                        Class="custom-class"
                        controlFunc={(e) => {
                          handleInputChange(e, index, "itemname");
                        }}
                        controlFuncBlur={(e) => handleBlur(e, index)} // optional
                      />
                    </td>






                    {/* U.O.M */}
                    <td className="border px-2 py-2 w-[140px]">
                      <InputText
                        inputType="text"
                        name="uom"
                        content={row.uom}
                        controlFunc={(e) => {
                          const InputText = e.target.value;

                          if (/^[A-Za-z]*$/.test(InputText)) {
                            handleInputChange(e.target, index, "uom");
                          }
                        }}
                        controlFuncBlur={handleBlur}
                        disabled={true}
                      />
                    </td>
                    {/* Quantity */}
                    <td className="border px-2 py-2 w-[120px]">
                       <div title={`${updateScreenTitle ? 'Max Add:' : "Available Stock:"} ${row.currentStock || 0}`}>
                     
                      <InputText
                        inputType="number"
                        name="quantity"
                        errorMessage={errors.quantity}
                        content={row.quantity}
                        controlFunc={(e) => {
                          const inputValue = e.target.value;
                      
                          // Allow empty OR digits
                          if (inputValue === "" || /^\d+$/.test(inputValue)) {
                            // Check stock condition immediately
                            if (
                              inputValue !== "" &&
                              parseFloat(inputValue) > (row.currentStock || 0)
                            ) {
                              // Clear instantly
                              handleInputChange({ value: "" }, index, "quantity");
                            } else {
                              handleInputChange(e.target, index, "quantity");
                            }
                          }
                        }}
                        //controlFuncBlur={handleBlur}

                       controlFuncBlur={(e) => {
  const inputValue = e.target.value;

  if (
    inputValue !== "" &&
    parseFloat(inputValue) > (row.currentStock || 0)
  ) {
    handleInputChange({ value: "" }, index, "quantity");
  }
}}

                      /></div>
                    </td>



                    {/* Action */}
                    <td className="border px-4 py-2 w-[100px]">
                      <div className="flex gap-4 items-center justify-center">
                        {/* Delete Icon */}
                        <svg
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          className="w-6 h-6 text-black cursor-pointer"
                          onClick={() => handleDeleteRow(index)}
                        >
                          <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                        </svg>

                        {/* Add Icon */}
                        {index === tableData.length - 1 && tableData.length < 4 && (
                          <svg
                            viewBox="0 0 1024 1024"
                            fill="currentColor"
                            onClick={handleAddRow}
                            className="w-6 h-6 text-black cursor-pointer"
                          >
                            <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                          </svg>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {tableError && (
     <p className="text-red-600 font-semibold text-sm mt-4">
      {tableError}
    </p>
  )}
          </div>

          <div className="mt-4">

            <TextArea
              inputType="text"
              title="Reason"
              name="reason"
              rows="4"
              maxlength={500}
              content={formFields.reason}
              placeholder="Enter Reason"
              controlFunc={handleInputChangeForm}
            />
          </div>

          <div className="flex justify-center mt-24">
            <Buttons
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              disabledBtn={false}
              viewSaveButton={false}
              handleSubmit={handleSubmit}
              cancel={cancel}
            />
          </div>
        </div>
      )}

      <MainPopup popUpOpen={popUpOpen} setpopUpOpen={setpopUpOpen} Open={handleConsumption}>
        <div>
          <PopUpScreenTitle
            title="Consumption"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <Consumptionpopup data={mainconsumeRecord} data1={consumemainTableData}  />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          handleSubmit={handleSubmit}
          cancel={cancel}
          rowIndex={rowIndex}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>

      <MainPopup popUpOpen={viewpopUpOpen} setpopUpOpen={setviewpopUpOpen}
        Open={onConsumptionView}>
        <div>
          <PopUpScreenTitle
            title="Consumption"
            setpopUpOpen={setviewpopUpOpen}
            viewDetails={setviewpopUpOpen}


          />
          <ConsumptionViewPopUp data={consumeRecord} data1={consumeTableData} />
        </div>
        <PopUpButtons


          cancel={cancelview}
          rowIndex={rowIndex}
          disabledBtn={submitBtnDisabled}

        />
      </MainPopup>
    </MainLayout>
  );
};

export default Consumption;
